var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "filter-item" }, [
    _c("input", {
      staticClass: "filter-item__checkbox",
      attrs: { type: "checkbox", id: _vm.id, name: _vm.name },
      domProps: { value: _vm.value },
      on: { click: _vm.clickHandler },
    }),
    _vm._v(" "),
    _c("label", { staticClass: "filter-item__label", attrs: { for: _vm.id } }, [
      _vm._v("\n        " + _vm._s(_vm.label) + "\n    "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/components/FilterItem.vue